import { Badge } from 'antd';
import { memo } from 'react';
import type { ReactNode } from 'react';
import { useList } from './useApi';
import { useSiderTodoBadge } from 'hooks/business/useSiderTodoBadge';

const TodoBadge = (props: { children: ReactNode }) => {
  useList();
  const badgeType = useSiderTodoBadge();
  return (
    <Badge dot={!!badgeType} color={badgeType}>
      {props.children}
    </Badge>
  );
};

export default memo(TodoBadge);
